/**
 * Renders a legal document from a simple block array.
 * Supported block shapes:
 *   { type: 'heading', text: string }
 *   { type: 'paragraph', text: string }
 *   { type: 'list', items: string[] }
 */
import { openInAppBrowser } from '../../utils/capacitor';

const LegalContent = ({ blocks = [] }) => {
  return (
    <div className="legal-prose space-y-5 text-foreground/85 leading-relaxed">
      {blocks.map((block, idx) => {
        if (block.type === 'heading') {
          return (
            <h2
              key={idx}
              className="font-heading font-semibold text-xl mt-6 first:mt-0 text-foreground"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === 'list') {
          return (
            <ul key={idx} className="list-disc pl-6 space-y-2">
              {block.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        }
        if (block.type === 'links') {
          return (
            <ul key={idx} className="list-disc pl-6 space-y-3" data-testid="sources-links">
              {block.items.map((item, i) => (
                <li key={i}>
                  <a
                    href={item.url}
                    onClick={(e) => { e.preventDefault(); openInAppBrowser(item.url); }}
                    className="text-accent hover:underline break-words cursor-pointer"
                    data-testid={`source-link-${i}`}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={idx} className="whitespace-pre-line">
            {block.text}
          </p>
        );
      })}
    </div>
  );
};

export default LegalContent;
